<section class="form-section" [ngClass]="{'small-info': !info, 'full-width': fullWidth}">
  <h2 class="form-section__title">{{ title }}</h2>
  <div class="form-section__info">
    <h3 class="form-section__subtitle">{{ subtitle }}</h3>
    <p class="form-section__desc">{{ description }}</p>
  </div>
  <ng-content></ng-content>
</section>
